"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useTheme } from "@mui/material/styles";

const ChatwootChat = () => {
  const pathname = usePathname();
  const theme = useTheme();

  const showChatWidget = () => {
    if (window.$chatwoot && window.$chatwoot.toggleBubbleVisibility) {
      window.$chatwoot.toggleBubbleVisibility("show");
    }
  };

  const hideChatWidget = () => {
    if (window.$chatwoot && window.$chatwoot.toggleBubbleVisibility) {
      window.$chatwoot.toggleBubbleVisibility("hide");
    }
  };

  const isChatOpen = () => {
    const chatWidget = document.querySelector(".woot-widget-holder");
    return chatWidget && chatWidget.classList.contains("woot-widget--expanded");
  };

  const isTablet = () => {
    const ua = navigator.userAgent.toLowerCase();
    const isTabletUA =
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        ua,
      );
    const isTabletWidth = window.innerWidth >= 768 && window.innerWidth <= 1024;
    return isTabletUA || isTabletWidth;
  };

  const waitForChatwootReady = (callback, maxAttempts = 50) => {
    let attempts = 0;
    const checkChatwoot = () => {
      if (
        (window.$chatwoot && window.$chatwoot.toggleBubbleVisibility) ||
        attempts >= maxAttempts
      ) {
        callback();
      } else {
        attempts++;
        setTimeout(checkChatwoot, 100);
      }
    };
    checkChatwoot();
  };

  useEffect(() => {
    // Chatwoot is temporarily disabled
    return;

    // Block loading on tablets
    if (isTablet()) {
      console.log("Chatwoot: Blocked on tablet device");
      return;
    }

    const allowedDomains = ["hub.meex.co", "meex.co"];
    const currentDomain = window.location.hostname;

    if (!allowedDomains.includes(currentDomain)) {
      console.warn("Chatwoot: Domain not authorized", currentDomain);
      return;
    }

    const CHAT_BASE_URL = process.env.NEXT_PUBLIC_CHATWOOT_BASE_URL;
    const CHAT_WEBSITE_TOKEN = process.env.NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN;

    if (!CHAT_BASE_URL || !CHAT_WEBSITE_TOKEN) {
      console.error("Chatwoot environment variables not found");
      return;
    }

    // ...existing code...
    if (!window.chatwootSDK) {
      window.chatwootSettings = {
        position: "right",
        type: "standard",
        launcherTitle: "Talk to our support team",
        hideMessageBubble: true,
        darkMode: theme.palette.mode,
      };

      const script = document.createElement("script");
      script.src = CHAT_BASE_URL + "/packs/js/sdk.js";
      script.async = true;

      script.onload = function () {
        window.chatwootSDK.run({
          websiteToken: CHAT_WEBSITE_TOKEN,
          baseUrl: CHAT_BASE_URL,
        });

        window.addEventListener("chatwoot:ready", function () {
          if (pathname === "/support") {
            showChatWidget();
          }
        });
      };

      script.onerror = function () {
        console.error(
          "Failed to load Chatwoot script from:",
          CHAT_BASE_URL + "/packs/js/sdk.js",
        );
      };

      const firstScript = document.getElementsByTagName("script")[0];
      if (firstScript) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
    } else {
      waitForChatwootReady(() => {
        if (pathname === "/support") {
          showChatWidget();
        } else {
          if (!isChatOpen()) {
            hideChatWidget();
          }
        }
      });
    }
  }, [pathname, theme.palette.mode]);

  return null;
};

export default ChatwootChat;
